import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=531360f0"
import script from "./HomeMain.vue?vue&type=script&lang=ts"
export * from "./HomeMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports